/**
 * Rest Client class
 * Responsible for consuming Api Endpoints
 *
 * * getRequest
 * * postRequest
 * * putRequest
 * * deleteRequest
 */
import axios from 'axios'
import Configuration from '../api/Configuration'
import './Axios'

axios.defaults.withCredentials = true

class RestClient {
  constructor() {
    this.config = new Configuration()
  }

  static getRequest = async (url, config) => axios
    .get(url, config)
    .then((response) => response)
    .catch((error) => error.response)

  static postRequest = (url, data, config) => axios
    .post(url, data, config)
    .then((response) => response)
    .catch((error) => error.response)

  static putRequest = (url, data, config) => axios
    .put(url, data, config)
    .then((response) => response)
    .catch((error) => error.response)

  static patchRequest = (url, data, config) => axios
    .patch(url, data, config)
    .then((response) => response)
    .catch((error) => error.response)

  static deleteRequest = (url, config) => axios
    .delete(url, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export default RestClient
